import { ConfigurationType, SystemOptionType } from 'data/types';
import { buildDuctedDesignLayoutConfiguration } from 'utils/ducted-design-layout';
import { isDuctedCompatibilitySystem } from 'utils/ducted-quote-layout';
import { PickKind, pickSystemNameFor } from './equipment-comparison-utils';

export type ComparisonSectionRowCount = 3 | 4;

export function showsComparisonZoningLayout(
  system: SystemOptionType,
  configurations: ConfigurationType[]
): boolean {
  if (!isDuctedCompatibilitySystem(system)) return true;
  return (
    buildDuctedDesignLayoutConfiguration({ system, configurations }) !== null
  );
}

export function comparisonSectionRowCount(
  systems: ReadonlyArray<SystemOptionType>,
  configurations: ConfigurationType[]
): ComparisonSectionRowCount {
  if (
    systems.length > 0 &&
    systems.every(
      (system) => !showsComparisonZoningLayout(system, configurations)
    )
  ) {
    return 3;
  }
  return 4;
}

export function resolveSystemName(
  system: SystemOptionType,
  pickKind: PickKind | null,
  systemNumber: number
): string {
  if (pickKind) return pickSystemNameFor(pickKind);
  const curated = system.name?.trim();
  if (curated) return curated;
  return `System ${systemNumber}`;
}
